A non-negative limit to the number of questions to return.

Defaults to 10.
